import $ from 'jquery';
import * as headerCart from 'header.cart';
import * as headerLogo from 'header.logo';
import * as headerMyAccountDrawer from 'header.myaccountdrawer';
import * as headerSimpleFlyout from 'header.simpleflyout';
import * as headerMyaccount from 'header.myaccount';
import * as headerStorefinderCore from 'header.storefinder.core';
import * as headerStoreFinderInline from 'header.storefinder.inline';
import * as headerTooltips from 'header.tooltips';
import * as headerSearchLite from 'header.search.lite';
import * as footerSmartBanner from 'footer.smartBanner';
import * as footerPclink from 'footer.pcLink';
import * as gestureHandler from 'global.gestureHandler';
import * as headerAnalytics from 'header.analytics';
import * as headerSticky from 'header.sticky';
import localizationDrawer from 'localization-drawer';
import DeliveryZip from 'header.deliveryzip';
import * as headerCartReminder from 'header.cartReminders';

(function () {
  const readyEvent = document.createEvent('CustomEvent');
  readyEvent.initCustomEvent('hfapp-ready', true, false, {});
  headerAnalytics.init();
  headerCart.init();
  headerSimpleFlyout.init();
  headerLogo.init();
  headerMyAccountDrawer.init();
  headerSearchLite.init();
  headerMyaccount.init();
  headerTooltips.init();
  headerStorefinderCore.init();
  headerStoreFinderInline.init();
  footerSmartBanner.init();
  footerPclink.init();
  gestureHandler.init();
  headerSticky.init();
  DeliveryZip.init();
  headerCartReminder.init();

  // Triggers HFApp is loaded and ready
  $('body').trigger('hfapp-ready');
  document.dispatchEvent(readyEvent);
})();
